import { DragIndicator } from '@mui/icons-material';
import { Box, ListItem, ListItemIcon, ListItemText, Paper, Tooltip, Typography } from '@mui/material';
import { useDrag } from 'react-dnd';
import { PolicyRule } from '../../model/interfaces/policyRule';
import { DragAndDropTypes } from '../../model/dragAndDropTypes';

interface RuleProps {
  rule: PolicyRule;
}

const MovableListing = (props: RuleProps) => {
  const { rule } = props;

  const [{ isDragging }, drag] = useDrag(() => ({
    type: DragAndDropTypes.RULELISTING,
    item: { rule },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging()
    })
  }));

  return (
    <Box ref={drag} style={{ opacity: isDragging ? 0.5 : 1, cursor: 'move' }}>
      <Paper elevation={0} sx={{ backgroundColor: 'transparent' }}>
        <Tooltip title={rule.description}>
          <ListItem
            component={Paper}
            variant="outlined"
            elevation={0}
            sx={{
              backgroundColor: '#fff',
              border: '1px solid #E3E2DE',
              paddingY: 1,
              paddingX: 1.25,
              gap: 1,
              borderRadius: '6px',
              '&:hover': { borderColor: '#3B82F6' }
            }}
          >
            <ListItemIcon sx={{ minWidth: 0, color: '#b5b5b5' }}>
              <DragIndicator fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{
                sx: { overflow: 'hidden', textOverflow: 'ellipsis' },
                noWrap: true
              }}
              secondaryTypographyProps={{
                sx: { overflow: 'hidden', textOverflow: 'ellipsis' },
                noWrap: true
              }}
              primary={<Typography variant={'body2'}> {rule.name} </Typography>}
              secondary={<Typography variant={'caption'}> {rule.description} </Typography>}
            />
          </ListItem>
        </Tooltip>
      </Paper>
    </Box>
  );
};

export default MovableListing;
